<template>
  <div>
    <!-- Filtros de búsqueda con botón -->
    <div class="ibox sombra-light">
      <div class="ibox-title">
        <h5>
          <i class="fal fa-calendar-alt"></i> Agenda de Citas
        </h5>
      </div>
      <div class="ibox-content">
        <b-overlay :show="loading" rounded="sm">
          <div class="row">
            <!-- filter by Establishments (searchable) -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Establecimientos</label>
                <v-select
                  v-model="filters.establishment"
                  :options="establishments"
                  :reduce="option => option.value"
                  placeholder="Seleccionar establecimiento"
                  label="text"
                  searchable
                  required
                ></v-select>
              </div>
            </div>
            <!-- filter by Specialties (searchable) -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Especialidades</label>
                <v-select
                  v-model="filters.specialty"
                  :options="specialties"
                  :reduce="option => option.value"
                  placeholder="Seleccionar especialidad"
                  label="text"
                  searchable
                  :class="{'is-invalid': !filters.specialty && showValidationError}"
                ></v-select>
                <div v-if="!filters.specialty && showValidationError" class="invalid-feedback">
                  Este campo es requerido.
                </div>
              </div>
            </div>
            <!-- Servicio (searchable) -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Servicios</label>
                <v-select
                  v-model="filters.service"
                  :options="services"
                  :reduce="option => option.value"
                  placeholder="Seleccionar servicio"
                  label="text"
                  searchable
                ></v-select>
              </div>
            </div>
            <!-- Profesional (searchable) -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Profesional</label>
                <v-select
                  v-model="filters.professional"
                  :options="professionals"
                  :reduce="option => option.value"
                  placeholder="Seleccionar profesional"
                  label="text"
                  searchable
                ></v-select>
              </div>
            </div>
            <!-- Estado de la cita (multiple select) -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Estado de la cita</label>
                <v-select
                  v-model="filters.status"
                  :options="statusHora"
                  :reduce="option => option.value"
                  placeholder="Seleccionar estado"
                  label="text"
                  searchable
                  multiple
                ></v-select>
              </div>
            </div>

            <!-- plan de salud -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Planes de Salud</label>
                <v-select
                  v-model="filters.plan"
                  :options="planes"
                  :reduce="option => option.value"
                  placeholder="Seleccionar plan de salud"
                  label="text"
                  searchable
                ></v-select>
              </div>
            </div>

            <!-- Fecha -->
            <div class="col-md-4">
              <div class="form-group">
                <label>Seleccione el día</label>
                <b-form-datepicker v-model="filters.date" placeholder="Seleccionar el dia"
                                   class="mb-2"></b-form-datepicker>
              </div>
            </div>
            <!-- Botón de búsqueda -->
            <div class="col-md-12">
              <b-button
                block variant="primary"
                type="submit"
                :disabled="loading"
                class="buscar-info-dashboard"
                @click="search"
              >
                Buscar
              </b-button>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>

    <!-- Tabla de resultados -->
    <div class="ibox">
      <div class="ibox-content" id="custom-table">
        <div v-if="cupos">
          <vue-good-table
            :columns="columns"
            :rows="cupos"
            :lineNumbers="true"
            max-height="500px"
            :pagination-options="{
              enabled: true,
              perPage: 5,
              perPageDropdown: [3, 7, 9],
            }"
            :searchOptions="{ enabled: true }"
            class="custom-table"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'paciente'">
                {{ props.row.paciente ? props.row.paciente.nombre_completo : 'N/P' }}
              </span>
              <span v-else-if="props.column.field === 'acción'">
                <b-dropdown text="Seleccionar" variant="outline-secondary">
                  <b-dropdown-item
                    v-if="props.row.estado_cita === 'Disponible'"
                    @click="showPreReserveModal(props.row)"
                  >
                    Reservar
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="props.row.estado_cita === 'agendada'"
                    @click="changeStatus(props.row.id, 'conf')"
                  >
                    Confirmar
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="props.row.estado_cita === 'agendada' || props.row.estado_cita === 'confirmada'"
                    @click="changeStatus(props.row.id, 'anul')"
                  >
                    Anular
                  </b-dropdown-item>
                </b-dropdown>
              </span>
              <span v-else class="truncate">
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>

    <!-- Modal para mostrar información del paciente -->
    <b-modal
      v-if="cupoSelected"
      ref="modalPatientReserve"
      hide-footer
      title="Detalles de la Reserva"
      size="lg"
      centered
      :header-bg-variant="'primary'"
      :header-text-variant="'white'"
    >
      <b-overlay :show="loadingReserve" rounded="sm">
        <h3>Datos del Paciente</h3>
        <hr>

        <!-- Birthdate and Document -->
        <div class="row">
          <div class="col-md-6">
            <label for="birthdateInput" class="form-label">Fecha de Nacimiento</label>
            <b-form-datepicker
              id="birthdateInput"
              v-model="patientInfo.birthdate"
              placeholder="Seleccione la fecha de nacimiento"
              required
            ></b-form-datepicker>
          </div>
          <div class="col-md-6">
            <label for="documentInput" class="form-label">Documento</label>
            <div class="input-group">
              <b-form-input
                id="documentInput"
                v-model="patientInfo.documento"
                type="text"
                placeholder="Ingrese el documento del paciente"
                required
              ></b-form-input>
              <b-button
                variant="primary"
                @click="getPatientInfo"
              >
                <i class="fas fa-search"></i>
              </b-button>
            </div>
          </div>
        </div>

        <!-- Name and Lastname -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nombre">Nombres</label>
              <input
                type="text"
                class="form-control"
                id="names"
                v-model="patientInfo.nombres"
                placeholder="Nombres"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="apellido">Apellidos</label>
              <input
                type="text"
                class="form-control"
                id="las_names"
                v-model="patientInfo.apellidos"
                placeholder="Apellidos"
              />
            </div>
          </div>
        </div>

        <!-- Email and Phone -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="rut">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="patientInfo.email_paciente"
                placeholder="Email"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="rut">Telefono</label>
              <input
                type="text"
                class="form-control"
                id="phone"
                v-model="patientInfo.telefono_paciente"
                placeholder="Telefono"
              />
            </div>
          </div>
        </div>

        <!-- Direccion -->
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="address">Dirección</label>
              <textarea
                class="form-control"
                id="address"
                v-model="patientInfo.direccion"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>

        <br>

        <h3>Información de la Cita</h3>
        <hr>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="rut">Estado de la Cita</label>
              <input
                readonly
                type="text"
                class="form-control"
                v-model="cupoSelected.estado_cita"
                placeholder="Estado de la Cita"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="rut">Hora Inicio</label>
              <input
                readonly
                type="text"
                class="form-control"
                v-model="cupoSelected.hora_inicio"
                placeholder="Hora de Inicio"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="rut">Duración</label>
              <input
                readonly
                type="text"
                class="form-control"
                v-model="cupoSelected.duracion"
                placeholder="Duracion"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="rut">Especialidad</label>
              <input
                readonly
                type="text"
                class="form-control"
                v-model="cupoSelected.especialidad.nombre"
                placeholder="Especialidad"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="rut">Nombre del Doctor</label>
              <input
                readonly
                type="text"
                class="form-control"
                v-model="cupoSelected.profesional.nombre"
                placeholder="Nombre del Doctor"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="rut">Establecimiento</label>
              <input
                readonly
                type="text"
                class="form-control"
                v-model="cupoSelected.establecimiento"
                placeholder="Estado de la Cita"
              />
            </div>
          </div>
        </div>

        <div class="mt-4 text-end">
          <button type="submit" class="btn btn-primary" @click="reserve">Reservar</button>
          <button type="button" class="btn btn-secondary" @click="clearPatientInfo">
            Cancelar
          </button>
        </div>
      </b-overlay>
    </b-modal>

  </div>
</template>

<script>
import vSelect from 'vue-select';
import {VueGoodTable} from 'vue-good-table';

export default {
  components: {vSelect, VueGoodTable},
  data() {
    return {
      filters: {
        establishment: null,
        specialty: null,
        service: null,
        professional: null,
        status: [],
        date: this.getTodayDate(),
        plan: null,
      },
      statusHora: [],
      establishments: [],
      services: [],
      specialties: [],
      professionals: [],
      planes: [],
      cupos: [],
      mas_proximo: '',

      showValidationError: false,

      loading: false,
      loadingReserve: false,

      cupoSelected: {
        hora_inicio: '',
        duracion: '',
        estado_cita: '',
        establecimiento: '',
        profesional: {},
        especialidad: {}
      },

      showModalPatientInfo: false,
      patientInfo: {
        id_paciente: null,
        nombres: null,
        apellidos: null,
        email_paciente: null,
        telefono_paciente: null,
        rut_fmt: null,
        uuid_paciente: null,
        direccion: null,
        birthdate: null,
      },

      columns: [
        {label: "ID", field: "id", sortable: true, width: '10%'},
        {label: "Hora Inicio", field: "hora_inicio", sortable: true},
        {label: "Duración", field: "duracion", sortable: true},
        {label: "Estado Cita", field: "estado_cita", sortable: true},
        {label: "Nombre Profesional", field: "nombre_profesional", sortable: true},
        {label: "Especialidad", field: "especialidad.nombre", sortable: true},
        {label: "Centro Médico", field: "centro_medico", sortable: true},
        {label: "Paciente", field: "paciente", sortable: false},
        {label: "Acción", field: "acción", sortable: false},
      ],
    };
  },
  mounted() {
    this.loadFilters();
  },
  methods: {
    async loadFilters() {
      try {
        this.loading = true;
        await Promise.all([
          this.fetchEstablishment(),
          this.fetchSpecialties(),
          this.fetchServices(),
          this.fetchProfessionals(),
          this.fetchEstadoHora(),
          this.fetchPlanes(),
        ]);
      } catch (error) {
        console.error('Error al cargar filtros:', error);
      } finally {
        this.loading = false;
      }
    },
    getTodayDate() {
      const today = new Date();
      return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    },
    async fetchEstadoHora() {
      try {
        const response = await axios.get('api/estado-hora/select');
        this.statusHora = response.data.map(estadoHora => ({
          value: estadoHora.id,
          text: estadoHora.nombre
        }));
      } catch (error) {
        console.error('Error al cargar los estados de las horas:', error);
      }
    },
    async fetchEstablishment() {
      try {
        const response = await axios.get('api/establecimientos/select');
        this.establishments = response.data.map(establishment => ({
          value: establishment.id,
          text: establishment.nombre
        }));
      } catch (error) {
        console.error('Error al cargar establecimientos:', error);
      }
    },
    async fetchSpecialties() {
      try {
        const response = await axios.get('api/especialidades/select');
        this.specialties = response.data.map(specialty => ({
          value: specialty.UUID,
          text: specialty.nombre
        }));
      } catch (error) {
        console.error('Error al cargar especialidades:', error);
      }
    },
    async fetchServices() {
      try {
        const response = await axios.get('api/servicios/select');
        this.services = response.data.map(service => ({
          value: service.UUID,
          text: service.nombre
        }));
      } catch (error) {
        console.error('Error al cargar servicios:', error);
      }
    },
    async fetchProfessionals() {
      try {
        const response = await axios.get('api/profesionales/select');
        this.professionals = response.data.map(professional => ({
          value: professional.id,
          text: professional?.nombres + ' ' + professional?.apellidos
        }));
      } catch (error) {
        console.error('Error al cargar profesionales:', error);
      }
    },
    async fetchPlanes() {
      try {
        const response = await axios.get('api/planes/select');
        this.planes = response.data.map(plan => ({
          value: plan.UUID,
          text: plan.nombre
        }));
      } catch (error) {
        console.error('Error al cargar planes:', error);
      }
    },
    async search() {
      this.loading = true;
      this.validateField('specialty');

      if (!this.showValidationError) {
        const response = await axios.post('/api/agenda/cupos', {
          establishment_id: this.filters.establishment,
          specialty_id: this.filters.specialty,
          service_id: this.filters.service,
          professional: this.filters.professional,
          estado_hora: this.filters.status,
          initial_date: this.filters.date,
          plan: this.filters.plan,
        });
        this.cupos = response.data.cupos;
        this.mas_proximo = response.mas_proximo
      }

      this.loading = false;
    },
    validateField(field) {
      this.showValidationError = !this.filters[field];
    },
    async getPatientInfo() {
      try {
        const response = await axios.post('/api/agenda/buscar-paciente', {
          identity_number: this.patientInfo.documento,
          birthdate: this.patientInfo.birthdate,
        });

        this.patientInfo = {...this.patientInfo, ...response.data.response.paciente};
      } catch (error) {
        console.error('Error al buscar paciente:', error);
        throw error;
      }
    },
    async showPreReserveModal(cupo) {
      this.cupoSelected = {
        id: cupo.id,
        hora_inicio: cupo.hora_inicio,
        duracion: cupo.duracion,
        estado_cita: cupo.estado_cita,
        establecimiento: cupo.establecimiento,
        profesional: cupo.doctor,
        especialidad: cupo.especialidad,
      };
      this.showModalPatientInfo = true;
      this.$refs['modalPatientReserve'].show();
    },
    async reserve() {

      this.loadingReserve = true;
      let data = {
        profesional: this.filters.professional,
        paciente: this.patientInfo,
        cupo: this.cupoSelected,
      };

      let icon = 'error';
      let title = 'Error';
      let message = '';

      try {
        const response = await axios.post('/api/agenda/agendar-cita', data);

        if ( response.data.http_code == 409 ) {
          message = 'Error al intentar reservar una cita con la misma especialidad.';
        }
        else if ( response.data.http_code == 412 ) {
          message = 'ha ocurrido un error al intentar reservar la cita.';
        }
        else {
          icon = 'success';
          title = 'Agenda de Citas';
          message = 'Cita reservada con exito.';
        }

        this.$swal({
          icon: icon,
          title: title,
          text: message,
        });

        this.clearPatientInfo();
        this.search();

      } catch (error) {
        console.error('Error al reservar cita:', error);
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ha ocurrido un error al intentar reservar la cita.',
        });
      }
      this.loadingReserve = false;
    },
    clearPatientInfo() {
      this.patientInfo = {
        id_paciente: null,
        nombres: null,
        apellidos: null,
        email_paciente: null,
        telefono_paciente: null,
        rut_fmt: null,
        uuid_paciente: null,
        direccion: null,
        birthdate: null,
      };

      this.$refs['modalPatientReserve'].hide();
    },
    async changeStatus(id, status) {
      let message = status === 'conf' ? 'Confirmado' : 'Anulado';
      try {
        const response = await axios.post('/api/agenda/actualizar-estado-cita', {
          idHora: id,
          estado: status
        });
        this.$bvToast.toast(`Se ha ${message} la cita`, {
          title: 'Estado actualizado',
          variant: 'success',
          solid: true
        });

        this.$swal({
          icon: 'success',
          title: 'Estado de la Citas',
          text: 'El estado de la cita fue actualizado con exito.',
        });

        await this.search();

      } catch (error) {
        console.error('Error al actualizar el estado de la cita:', error);
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ha ocurrido un error al intentar actualizar el estado de la cita.',
        });
      }
    },
  },
};
</script>

<style scoped>
.is-invalid {
  border: 1px solid red !important;
  border-radius: 4px;
}

.truncate {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#custom-table {
  font-family: none;
}
</style>
